import React, {FC} from 'react';
import {connect} from 'react-redux';

import {DataEventTrackingProvider} from '../../../../libs/shared/core/src/services/tracking/dataEventTrackingProvider';
import {ResolveDispatchProps} from '../../../../libs/shared/core/src/store/helpers/reduxHelpers';
import {LightUserThemeProvider} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {makeMapDispatchToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {saveOnboardingQuestionnaireAnswersAction} from '../../../store/data/preferences/preferencesActions';
import {useOnboardingModalState} from '../../app/topBar/onboarding/onboardingContext';
import {OnboardingGuidesEnum} from '../guide/onboardingGuideTypes';
import {OnboardingQuestionnairePopover} from './onboardingQuestionnairePopover';

/*
 * Props.
 */

interface OnboardingQuestionnairePopoverContainerProps {}

type OnboardingQuestionnairePopoverContainerComponentProps = OnboardingQuestionnairePopoverContainerProps &
  ResolveDispatchProps<typeof mapDispatchToProps>;

/*
 * Component.
 */

const OnboardingQuestionnairePopoverContainerComponent: FC<
  OnboardingQuestionnairePopoverContainerComponentProps
> = (props) => {
  const {saveOnboardingQuestionnaireAnswers} = props;

  const {renderOnboardingGuideTransition, setOnboardingGuide, onboardingGuide} = useOnboardingModalState();

  return (
    <LightUserThemeProvider>
      <DataEventTrackingProvider context={{name: 'getting_started', payload: {}}}>
        {renderOnboardingGuideTransition(OnboardingGuidesEnum.QUESTIONNAIRE, (styles) => (
          <OnboardingQuestionnairePopover
            isQuestionnaireOpen={onboardingGuide === OnboardingGuidesEnum.QUESTIONNAIRE}
            onClose={() => {
              setOnboardingGuide(undefined);
            }}
            styles={styles}
            saveOnboardingQuestionnaireAnswers={saveOnboardingQuestionnaireAnswers}
          />
        ))}
      </DataEventTrackingProvider>
    </LightUserThemeProvider>
  );
};

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  saveOnboardingQuestionnaireAnswers: saveOnboardingQuestionnaireAnswersAction,
}));

export const OnboardingQuestionnairePopoverContainer = connect(
  null,
  mapDispatchToProps,
)(OnboardingQuestionnairePopoverContainerComponent);
